module.exports = __webpack_public_path__ + "static/images/containers/Stronghold/components/Direction/images/direction-B-lvl2-100.649addef.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Stronghold/components/Direction/images/direction-B-lvl2-100.png
// module id = 3380
// module chunks = 11